// Типы для маркетплейса
export interface MarketplaceUrlResponse {
    url: string;
}

export const marketplaceEndpoints = {
    getMarketplaceUrl: {
        query: () => "/marketplace-url",
    },
};

export const marketplaceTags = ["Marketplace"] as const;
